export const NO_CHARM_ID: number = 0;
export const CHARM_ROW_LIMIT = 6;
